// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M73J","comment":"styles_comment__2nBDl"};